<template xmlns:v-field-control="http://www.w3.org/1999/xhtml">
    <div>
        <div class="flex-grid a-form-inputs">
            <form class="m-form" @submit.prevent>
                <div class="flex-grid__item">
                    <control label="Deceased Name" v-if="showNames">
                        <input autocomplete="off" @input="update" v-model="theDeceased.name"
                               required
                               name="deceased_name"
                               maxlength="100"
                               v-field-control:deceased_name.required="{type:'text', rules:'name'}"
                               type="text">
                        <control-error :show="$error('deceased_name')">
                            The deceased's name is required and must be a valid name
                        </control-error>
                    </control>
                    <control for="deceased_gender" label="Deceased Gender">
                        <select v-field-control
                                required
                                name="deceased_gender"
                                @change="update"
                                v-model="theDeceased.gender">
                            <option :value="null" disabled hidden>Please select...</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                        <control-error :show="$error('deceased_gender')">
                            The deceased's gender is required
                        </control-error>
                    </control>
                    <control for="deceased_date_of_birth" label="Deceased Date of Birth">
                        <date-input v-model="theDeceased.dateOfBirth"
                                    v-field-control:deceased_date_of_birth.required="{type:'date'}"
                                    @input="update"></date-input>
                        <control-error :show="$error('deceased_date_of_birth') || !validDateOfBirth()">
                            The deceased's date of birth is required and must be in the format DD/MM/YYYY
                            and be at least the age of 18
                        </control-error>
                    </control>
                    <control for="onset_of_deceased_symptoms" :label="claimDetailsValue('diseaseOrAccident') === 'disease' ? 'Onset of Symptoms' : 'Date of Injury / Accident'">
                        <date-input v-model="theDeceased.onsetOfSymptoms"
                                    v-field-control:onset_of_deceased_symptoms.required="{type:'date', rules:'min:'+theDeceased.dateOfBirth +'|'+'max:'+theDeceased.dateOfDeath}"
                                    @input="update"></date-input>
                        <control-error :show="$error('onset_of_deceased_symptoms') || !validOnsetOfSymptoms()">
                            The onset of symptoms is required, it must be in the format DD/MM/YYYY and be before the
                            date of death and after the date of birth
                        </control-error>
                    </control>
                    <control for="deceased_date_of_death" label="Deceased Date of Death">
                        <date-input v-model="theDeceased.dateOfDeath"
                                    v-field-control:deceased_date_of_death.required="{type:'date'}"
                                    @input="update"></date-input>
                        <control-error :show="$error('deceased_date_of_death')">
                            The deceased's date of death is required, must be in the format DD/MM/YYYY and must be
                            within 9 years of the assessment date ({{assumedSettlement}})
                        </control-error>
                        <control-error :show="!validDateOfDeath()">
                            The deceased's date of death must be before the assumed settlement ({{assumedSettlement}})
                        </control-error>
                        <control-error :show="!validDateOfDeathDurtaion()">
                            The deceased's date of death must within 9 years of the assumed settlement ({{assumedSettlement}})
                        </control-error>
                        <control-error :show="!validDateOfDeathCurrent()">
                            The deceased's date of death must be in the past
                        </control-error>
                        <control-error :show="!validDateOfProceedings()">
                            The deceased's date of death must be before the issue of proceedings
                            ({{dateOfServiceProceedings}})
                        </control-error>
                        <control-error :show="!validDateOfDeathOnsetOfSymptoms()">
                            The deceased's date of death must be after the onset of symptoms
                        </control-error>
                    </control>
                    <life-expectancy label="Deceased's 'But For' Life Expectancy"
                                     :person="theDeceased"
                                     :type="'deceased'"
                                     :assumed-settlement="this.assumedSettlement"
                                     :stepValid="$valid() && isValid(2)"
                                     @update="updateLife"></life-expectancy>
                </div>
                <div class="flex-grid__item flex-grid--space-left">
                    <control label="Period Between Onset and Date of Death" before-after="years">
                        <input autocomplete="off" type="number" disabled class="disabled"
                               :value="periodBetweenOnsetAndDod" v-two-dp>
                    </control>
                    <control for="age_at_death" label="Deceased Age at Death" before-after="years-old">
                        <input autocomplete="off" disabled="disabled"
                               v-field-control:age_at_death
                               id="age_at_death" type="number"
                               name="age_at_death"
                               v-two-dp
                               min="18"
                               :value="theDeceased.ageAtDeath">
                        <control-error :show="$error('age_at_death')">
                            The deceased must have been at least 18 years old at the time of death
                        </control-error>
                    </control>
                    <control label="Period Between Deceased's DOD & Settlement" before-after="years">
                        <input autocomplete="off" name="deceased_and_settlement" type="number"
                               :value="periodDeathToSettlement"
                               v-field-control
                               min="0"
                               v-two-dp
                               readonly
                               disabled>
                    </control>
                    <control label="Deceased's Age at Assumed Settlement" tip-side="left" before-after="years-old">
                        <input autocomplete="off" type="number"
                               min="0"
                               v-field-control
                               :value="ageAtSettlement"
                               v-two-dp
                               disabled>
                        <control-error :show="periodDeathToSettlement < 0">
                            Date of assessment/trial must be after the date of death
                        </control-error>
                    </control>
                    <control label="Reduction in Deceased's Life Expectancy" before-after="years">
                        <input autocomplete="off" type="number" disabled class="disabled" :value="reductionInLifeExpectancy" min="0" v-two-dp>
                        <control-error :show="reductionInLifeExpectancy < 0">
                            The deceased must have a reduction in life expectancy
                        </control-error>
                    </control>
                </div>
            </form>
        </div>
        <step-button :next-valid="$valid() && isValid(2)"></step-button>

        <modal :name="'educationAttainment_' + uniqueId" no-default-button="true">
            <modal-content></modal-content>
        </modal>
    </div>
</template>
<script>
    import Vue from 'vue';
    import moment from 'moment';
    import LifeExpectancy from 'components/LifeExpectancy.vue';
    import {mapActions, mapGetters} from 'vuex';
    import StepButton from 'components/StepButton.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import {isStepValid, setStepValid} from 'services/routingMethods';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';

    export default {
        name: 'TheDeceased',
        created() {
            this.validDateOfProceedings();
            this.validOnsetOfSymptoms();
            this.validateDateOfDeath();
        },
        computed: {
            ...mapGetters('fatal/dependency/claimDetails', {
                claimDetailsValue: 'value'
            }),
            ...mapGetters('fatal/dependency/deceased', {
                deceasedValue: 'value'
            }),
            ...mapGetters('fatal/dependency/proceduralDates', ['date']),
            ...mapGetters('user', ['showNames']),
            theDeceased() {
                let theDeceased = {};
                Vue.util.extend(theDeceased, this.$store.getters['fatal/dependency/deceased/theDeceased']);
                return theDeceased;
            },
            levelOfEducation: {
                get() {
                    return this.claimDetailsValue('levelOfEducation');
                },
                set(value) {
                    this.updateTheClaim({key: 'levelOfEducation', value})
                }
            },
            disabledAtAccident: {
                get() {
                    return this.claimDetailsValue('disabled');
                },
                set(value) {
                    this.updateTheClaim({key: 'disabled', value})
                }
            },
            periodDeathToSettlement() {
                return this.deceasedValue('periodDeathToSettlement');
            },
            ageAtSettlement() {
                return this.deceasedValue('ageAtSettlement');
            },
            reductionInLifeExpectancy() {
                setStepValid((this.theDeceased.lifeExpectancy.ageAtDeath - this.theDeceased.ageAtDeath) > 0);
                return this.theDeceased.lifeExpectancy.ageAtDeath - this.theDeceased.ageAtDeath;
            },
            assumedSettlement() {
                return this.claimDetailsValue('assumedSettlement');
            },
            dateOfServiceProceedings() {
                return this.claimDetailsValue('serviceOfProceedings');
            },
            preLitOrLit() {
                return this.claimDetailsValue('proceduralStatus');
            },
            periodBetweenOnsetAndDod() {
                if (this.theDeceased.dateOfDeath === null || this.theDeceased.onsetOfSymptoms === null) {
                    return null;
                }

                return (moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY').diff(moment(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'), 'days') / 365.25).toFixed(2);
            },
            uniqueId() {
                return this._uid;
            },
        },
        mixins: [
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        components: {
            LifeExpectancy,
            StepButton,
            Control,
            ControlError,
            DateInput,
            Modal,
            ModalContent
        },
        watch: {
            '$form.$valid'(val) {
                setStepValid(val);
            }
        },
        methods: {
            ...mapActions('fatal/dependency/claimDetails', {
                updateTheClaim: 'update',
            }),
            ...mapActions('fatal/dependency/deceased', {
                updateTheDeceased: 'updateTheDeceased',
                updateTheDeceasedLifeExpectancy: 'updateTheDeceasedLifeExpectancy'
            }),
            ...mapActions('fatal/dependency', ['checkToUpdateMultipliers']),
            updateLife(lifeExpectancy) {
                this.updateTheDeceasedLifeExpectancy({lifeExpectancy})
                    .then(this.update.bind(this));
            },
            update() {
                this.updateTheDeceased(this.theDeceased);
                this.checkToUpdateMultipliers();
                this.validateDateOfDeath();
                this.validateReductionInLife();
            },
            updateRetiredAtDeath(event) {
                if (this.theDeceased.income.retired == 'true') {
                    this.disabledAtAccident = 0;
                }
            },
            validDateOfProceedings() {
                if (!this.theDeceased.dateOfDeath || this.claimDetailsValue.proceduralStatus !== 'litigated') {
                    return true;
                }
                let mDateOfDeath = moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
                return this.preLitOrLit === 'litigated' ? mDateOfDeath.isBefore(moment(this.dateOfServiceProceedings, 'DD/MM/YYYY')) : true;
            },
            validDateOfDeathOnsetOfSymptoms() {
                if (!this.theDeceased.dateOfDeath) {
                    return true;
                }
                let mDateOfDeath = moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
                return mDateOfDeath.isSameOrAfter(moment(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
            },
            validOnsetOfSymptoms() {
                if (!this.theDeceased.dateOfDeath) {
                    return true;
                }
                let mDateOfBirth = moment(this.theDeceased.dateOfBirth, 'DD/MM/YYYY');
                return mDateOfBirth.isBefore(moment(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
            },
            validDateOfBirth() {
                if (!this.theDeceased.dateOfBirth) {
                    return true;
                }
                let mDateOfBirth = moment(this.theDeceased.dateOfBirth, 'DD/MM/YYYY');
                return mDateOfBirth.isBefore(moment().subtract(18, 'years'));
            },
            validDateOfDeath() {
                if (!this.theDeceased.dateOfDeath) {
                    return true;
                }
                let mDateOfDeath = moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
                return (
                    mDateOfDeath.isBefore(moment(this.assumedSettlement, 'DD/MM/YYYY'))
                );
            },
            validDateOfDeathCurrent() {
                if (!this.theDeceased.dateOfDeath) {
                    return true;
                }
                return moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')
                    .isBefore(moment(), 'day');
            },
            validDateOfDeathDurtaion() {
                if (!this.theDeceased.dateOfDeath) {
                    return true;
                }
                let mDateOfDeath = moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
                return (
                    mDateOfDeath.isSameOrAfter(moment(this.assumedSettlement, 'DD/MM/YYYY').subtract(9, 'years'))
                );
            },
            validateDateOfDeath() {
                if (!this.theDeceased.dateOfDeath) {
                    return false;
                }
                let valid = this.validOnsetOfSymptoms() && this.validDateOfProceedings() &&
                    this.validDateOfDeath() && this.validDateOfDeathDurtaion() &&
                    this.validDateOfDeathCurrent();

                setStepValid(valid);
                return valid;
            },
            validateReductionInLife() {
                if (this.reductionInLifeExpectancy < 0) {
                    setStepValid(false);
                    return false;
                }

                return true;
            },
            isValid() {
                return isStepValid(2);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// TheDeceased.vue?0ab4baf0